module.exports = __webpack_public_path__ + "static/media/img_147380.319d45b4.png";